export const Store = {
    uploaders: [],
    userInfo: {},
    permissionData: [],
    engineUIImgs: [
        {
            name: 'coplane',
            lightImg: 'coplaneLight.png',
            lightCheckImg: 'coplaneLightCheck.png',
            darkImg: 'coplaneDark.png',
            darkCheckImg: 'coplaneDarkCheck.png',
        },
        {
            name: 'catalogTree',
            lightImg: 'treeLight.png',
            lightCheckImg: 'treeLightCheck.png',
            darkImg: 'treeDark.png',
            darkCheckImg: 'treeDarkCheck.png'
        },
        {
            name: 'attribute',
            lightImg: 'attrLight.png',
            lightCheckImg: 'attrLightCheck.png',
            darkImg: 'attrDark.png',
            darkCheckImg: 'attrDarkCheck.png',
        },
        {
            name: 'texture',
            lightImg: 'texLight.png',
            lightCheckImg: 'texLightCheck.png',
            darkImg: 'texDark.png',
            darkCheckImg: 'texDarkCheck.png',
        },
        {
            name: 'closeSysUI',
            lightImg: 'closeSysUILight.png',
            darkImg: 'closeSysUIDark.png',
        },
        {
            name: 'explode',
            lightImg: 'explodeLight.png',
            lightCheckImg: 'explodeLightCheck.png',
            darkImg: 'explodeDark.png',
            darkCheckImg: 'explodeDarkCheck.png',
        },
    ],

    // 开挖使用的纹理列表
    extrudeTextureList: [],

    // 正则校验
    DISPLAY_NAME: /^[\u4e00-\u9fa5_a-zA-Z0-9_\@_\#_\&_\*_\%_\(_\)_\（_\）_\/_\._\-_\\__\[_\]_\s_]*$/g,      // 名称(项目、文件夹、模型组、场景)
}